export const pvsystGetters = {
    inputData: (state) => state.inputData,
    globalIncline: (state)=> state.globalIncline,
    energieCompteurAC : (state) => state.energieCompteurAC,
};
